<template>
  <div class="animated fadeIn">
    <b-row class="mt-2 mb-2">
      <b-col>
        <h2>ผู้ใช้งานทั้งหมด</h2>
      </b-col>
      <!-- <b-col>
        <b-button
          @click="$router.push({ name: 'สร้างบริษัท'})"
          class="float-right"
          variant="primary"
        >สร้างบริษัท</b-button>
      </b-col>-->
    </b-row>
    <b-card>
      <b-row>
        <b-col lg="6" class="my-1">
          <b-form-group
            label="ค้นหา"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                v-model="filter"
                type="search"
                id="filterInput"
                placeholder="Type to Search"
              ></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col sm="5" md="6" class="my-1">
          <b-form-group
            label="จำนวนต่อหน้า"
            label-cols-sm="6"
            label-cols-md="4"
            label-cols-lg="3"
            label-align-sm="right"
            label-size="sm"
            label-for="perPageSelect"
            class="mb-0"
          >
            <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table
            :items="users"
            :fields="tableFields"
            striped
            responsive="sm"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filterIncludedFields="filterOn"
            @filtered="onFiltered"
          >
            <template slot="name" slot-scope="row">{{ row.item.name }}</template>

            <template slot="email" slot-scope="row">{{ row.item.email }}</template>

            <template
              slot="company"
              slot-scope="row"
            >{{ row.item.company ? row.item.company.name : 'ถูกลบ' }}</template>

            <template slot="phoneNumber" slot-scope="row">{{ row.item.phoneNumber }}</template>

            <template
              slot="createdAt"
              slot-scope="row"
            >{{ row.item.createdAt ? $moment(row.item.createdAt).format('LLL') : '' }}</template>

            <template slot="actions" slot-scope="row">
              <b-button
                v-if="row.item.company"
                variant="primary"
                size="sm"
                :to="{name: 'อัพเดทบริษัท', params: {companyId:row.item.company._id}}"
                class="mr-1"
                target="_blank"
              >จัดการ</b-button>
              <b-button variant="danger" size="sm" @click="deleteUser(row.item._id)" class="mr-1">ลบ</b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination
            size="md"
            :total-rows="totalUser"
            v-model="currentPage"
            :per-page="perPage"
            first-text="หน้าแรก"
            prev-text="หน้าที่แล้ว"
            next-text="หน้าถัดไป"
            last-text="หน้าสุดท้าย"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <ModalLoading />
  </div>
</template>

<script>
import ModalLoading from '../../../components/ModalLoading'

import User from '../../../services/http/User'

export default {
  components: {
    ModalLoading
  },
  data () {
    return {
      tableFields: [
        { key: 'name', label: 'ชื่อผู้ใช้งาน', class: 'text-center', sortable: true },
        { key: 'email', label: 'อีเมล', class: 'text-center' },
        { key: 'company', label: 'ชื่อบริษัท', class: 'text-center', sortable: true },
        { key: 'phoneNumber', label: 'เบอร์โทร', class: 'text-center' },
        { key: 'createdAt', label: 'สร้างเมื่อ', class: 'text-center', sortable: true },
        { key: 'actions', label: 'จัดการ' }
      ],
      users: [],
      totalUser: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 50, 100],
      filter: null,
      filterOn: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      Window.Event.$emit('showModalLoading')
      try {
        var user = new User()
        var users = await user.getUserAll()
        this.users = users.data
        this.totalUser = this.users.length
      } catch (error) {
        console.log(error)
      }
      Window.Event.$emit('closeModalLoading')
    },
    openCompanyEdit (company) {
      console.log('create')
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalUser = filteredItems.length
      this.currentPage = 1
    },
    async deleteUser (userId) {
      if (!confirm('ยืนยันลบ')) {
        return
      }
      let data = {
        userId: userId
      }
      let user = new User()
      try {
        let deleted = await user.deleteUser(data)
        if (deleted.code === 1) {
          alert('ลบแล้ว')
          this.users = this.users.filter(user => user._id !== userId)
          this.totalUser = this.users.length
        } else {
          alert('พบข้อผิดพลาด')
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
